import React, { useEffect, useState } from 'react';

const BiTextArea = ({ name, value, onChange, style, width, disabled, height, rows }) => {
    let dod = {
        width: width == null ? "" : ((width) + "px"),
        height: height == null ? "" : ((height) + "px")
    }

   
    const [text, setText] = useState("");

    useEffect(() => {
        if (value != null) {
            setText(value);
        } else {
            setText("");
        }

    }, [value]);

    const onBlured = (e) => {
        if (onChange != null) {
            let val = e.target.value;
            
                onChange({ target: { name: name, value: val } });
            
        }
    }

    return (
        <textarea
            type="text"
            rows={rows == null ? "" : (rows)}
            className="form-control form-control-sm biControlInline"
            name={name}
            disabled={disabled ? "disabled" : ""}
            style={{ ...style, ...dod }}
            onBlur={(e) => onBlured(e)}
            onChange={(e) => setText(e.target.value)}
            value={text} />
    );
}

export default BiTextArea;

